interface Props {
  planned: number;
  target: number;
  height?: number;
  showLabel?: boolean;
  /**
   * Fill colour instead of the status tones, e.g. an object colour (FAFD-56). Above 100 %
   * the bar turns amber: more planned than needed is a hint, not a conflict.
   */
  color?: string;
  className?: string;
}

export function UtilizationBar({ planned, target, height = 4, showLabel = false, color, className = '' }: Props) {
  const ratio = target > 0 ? planned / target : 0;
  const pct = Math.min(100, ratio * 100);
  const statusTone =
    ratio >= 0.98 ? 'bg-emerald-500' : ratio >= 0.85 ? 'bg-amber-500' : 'bg-orange-500';
  const customColor = color && ratio <= 1 ? color : undefined;
  const tone = color ? (customColor ? '' : 'bg-amber-500') : statusTone;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div
        className="flex-1 rounded-full bg-slate-100 overflow-hidden"
        style={{ height }}
        role="progressbar"
        aria-valuenow={Math.round(pct)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`h-full ${tone} transition-all`}
          // harness-ignore FE_STYLE_INLINE why: width and the optional object colour are runtime values
          style={{ width: `${pct}%`, background: customColor }}
        />
      </div>
      {showLabel && (
        <span className="text-[10px] tabular-nums text-slate-500">{Math.round(pct)}%</span>
      )}
    </div>
  );
}
